











import { computed, defineComponent, ref } from "@nuxtjs/composition-api";
import { useConfig } from "~/composables";
import MvStyle from "~/components/PageBuilder/components/MvStyle.vue";

export default defineComponent({
  name: "InsideNotice",
  components: {MvStyle},
  setup() {
    const { config } = useConfig();
    const isShowNotice = ref(null);
    const noticeContent = computed(
      () => config.value.top_notification_content || ""
    );
    const showTopNotification = computed(
      () => config.value.show_top_notification || 0
    );
    const notificationBg = computed(
      () => config.value.top_notification_background_color || ""
    );
    const customizeStyle = computed(
      () => config.value.top_notification_additional_style || ""
    );
    isShowNotice.value =
      showTopNotification.value && showTopNotification.value > 0 ? true : false;

    const handleScroll = function () {
      if (window.scrollY > 0) {
        document.getElementById("__layout").className = "";
        isShowNotice.value = false;
      } else if (showTopNotification.value && showTopNotification.value > 0) {
        isShowNotice.value = true;
        document.getElementById("__layout").className = "show-top-notification";
      }
    };

    if (process.client) {
      if (showTopNotification.value && showTopNotification.value > 0) {
        document.getElementById("__layout").className = "show-top-notification";
      }
    }
    return {
      isShowNotice,
      showTopNotification,
      notificationBg,
      customizeStyle,
      noticeContent,
      handleScroll,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
});
